import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import Can from '../../../../features/components/Can'
import ListItemsTable from '../../../../features/components/ListItemsTable'
import SocialAuthChecker from '../../../../features/components/SocialAuthChecker'
import CampaignTikTokEdit from '../../../../forms/Tiktok/CampaignForms/CampaignTikTokEdit'
import CampaignsChangeHistory from '../../CampaignsChangeHistory'

import useCampaignFetchData from '../../hooks'
import useGetTikTokCampaignActions from './useGetTikTokCampaignActions'

import { createCampaignSummaryPageLink } from '../../helpers'

import {
  campaignsSelector,
  campaignsIsLoadingSelector,
  campaignsWasLoadedSelector,
  campaignsErrorSelector,
  campaignUpdateSelector,
  campaignUpdateIsLoadingSelector,
  campaignDeleteSelector
} from '../../../../modules/selectors/campaigns'
import { selectedTikTokAdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { TIKTOK_PLATFORM } from '../../../../constants/selectLists/platformList'
import { ROUTE_PARAMS } from '../../../../constants/routes'

const TikTokCampaignsSection = () => {
  const campaigns = useSelector(campaignsSelector)

  const campaignUpdate = useSelector(campaignUpdateSelector)
  const campaignUpdateIsLoading = useSelector(campaignUpdateIsLoadingSelector)
  const { id: campaignUpdateId } = campaignUpdate

  const campaignDelete = useSelector(campaignDeleteSelector)
  const { id: campaignDeleteId, isLoading: campaignDeleteIsLoading } = campaignDelete

  const { id: tiktokAdAccountId, currency_symbol: currencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  const getCampaignsData = useCampaignFetchData({
    adAccountId: tiktokAdAccountId,
    platform: TIKTOK_PLATFORM
  })

  const summaryPageLinkExtraParams = useMemo(
    () => ({
      [ROUTE_PARAMS.adAccount]: tiktokAdAccountId
    }),
    [tiktokAdAccountId]
  )

  const getTikTokCampaignsActions = useGetTikTokCampaignActions()

  return (
    <SocialAuthChecker
      platform={TIKTOK_PLATFORM}
      dataFetch={getCampaignsData}
      adAccountId={tiktokAdAccountId}
      authFailureText="Please authenticate with TikTok to retrieve the list of campaigns."
    >
      <ListItemsTable
        items={campaigns}
        platform={TIKTOK_PLATFORM}
        currencySymbol={currencySymbol}
        isLoadingSelector={campaignsIsLoadingSelector}
        errorSelector={campaignsErrorSelector}
        wasLoadedSelector={campaignsWasLoadedSelector}
        createItemLinkHelper={createCampaignSummaryPageLink}
        createItemLinkExtraParams={summaryPageLinkExtraParams}
        getActionsDropdownOptions={getTikTokCampaignsActions}
        itemUpdatingId={campaignUpdateIsLoading ? campaignUpdateId : ''}
        itemDeletingId={campaignDeleteIsLoading ? campaignDeleteId : ''}
      />

      <Can I="update" a="Campaign">
        <CampaignTikTokEdit shouldBeCleared />
      </Can>
      <CampaignsChangeHistory platform={TIKTOK_PLATFORM} />
    </SocialAuthChecker>
  )
}

export default TikTokCampaignsSection
